import { Component, OnInit, Input } from '@angular/core';
import { AppConfig } from '../../../app.config';
import { HelpersService } from '../../../services/helpers.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-menu-panel',
  templateUrl: './menu-panel.component.html',
  styleUrls: ['./menu-panel.component.scss'],
})
export class MenuPanelComponent implements OnInit {
  @Input() navigationItems: any;
  @Input() header: string = '';
  @Input() icon: string = '';

  constructor(
    public appConfig: AppConfig,
    public helpersService: HelpersService,
    private translate: TranslateService,
  ) {}

  ngOnInit() {
    var partner = this.helpersService.getPartnerData();
  }
}
